import styled from 'styled-components';
import colors from '@theme/colors';

export const ForgotPasswordLink = styled.div`
  margin: 30px;
  a {
    color: ${colors.LINK};
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./components/layout/LoginPage.js